module.exports = __webpack_public_path__ + "img/reports-active.39006d37.svg";